// extracted by mini-css-extract-plugin
export var dataCell = "_pn-2";
export var dataRow = "_pn-0";
export var headerRow = "_pn-1";